export enum AB_TESTING_ACTION_TYPES {
  PARTICIPATED_IN_AB_TESTING_ANALYTICS = '[Analytics] [UI] User participated in AB Test',
}
